import { render } from "./AboutComponent.vue?vue&type=template&id=3a25e2df&scoped=true"
import script from "./AboutComponent.vue?vue&type=script&lang=js"
export * from "./AboutComponent.vue?vue&type=script&lang=js"

import "./AboutComponent.vue?vue&type=style&index=0&id=3a25e2df&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Projetos TWM\\eproc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a25e2df"]])

export default __exports__